import { FotoDTO } from './FotoDTO';

export class VeiculoDTO {
  ano: string;
  cor: string;
  marca: string;
  modelo: string;
  placa: string;
  tipoVeiculo: string;
  pertenceAoAssociado: boolean;
  algumaRodaTravada?: boolean;
  estaEmLocalFechado?: boolean;
  estaNoSubsolo?: boolean;
  outraParteDanificada?: string;
  parteDanificada?: string;
  fotos?: FotoDTO[];

  constructor(
    ano: string,
    cor: string,
    marca: string,
    modelo: string,
    placa: string,
    tipoVeiculo: string,
    pertenceAoAssociado: boolean,
    algumaRodaTravada?: boolean,
    estaEmLocalFechado?: boolean,
    estaNoSubsolo?: boolean,
    outraParteDanificada?: string,
    parteDanificada?: string,
    fotos?: FotoDTO[]
  ) {
    this.algumaRodaTravada = algumaRodaTravada;
    this.ano = ano;
    this.cor = cor;
    this.estaEmLocalFechado = estaEmLocalFechado;
    this.estaNoSubsolo = estaNoSubsolo;
    this.marca = marca;
    this.modelo = modelo;
    this.outraParteDanificada = outraParteDanificada;
    this.parteDanificada = parteDanificada;
    this.pertenceAoAssociado = pertenceAoAssociado;
    this.placa = placa;
    this.tipoVeiculo = tipoVeiculo;
    this.fotos = fotos;
  }
}
